// twt_config.js

const protocol = window.location.protocol;
const siteName = '';
const backendFolder = '/backend';
const isDev = process.env.NODE_ENV === 'development';

export const BASE_PATH = "/";
export const LOGIN_COOKIE_NAME = "IBC_CONSULTANTS";
export const SITE_TITLE = 'IBC Consultants';

// DEV → relative path (goes to http://localhost:3000/backend/... then proxied to Laravel)
// PROD → absolute path (adjust host as needed)
const prodHost = window.location.host || '127.0.0.1:8000';

export const API_BASE_URL = isDev
  ? `/api/`           // => '/backend/api/'
  : `${protocol}//${prodHost}${backendFolder}/api/`;

// If you render file URLs directly (e.g., <img src>), proxy can still handle '/backend/...'
export const BACKEND_FILE_URL = isDev
  ? `/storage/uploads/`
  : `${protocol}//${prodHost}${backendFolder}/public/storage/uploads/`;

export const SITE_URL = `${protocol}//${prodHost}${BASE_PATH}`;
export const LANGUAGE_FOLDER_URL = SITE_URL;

